// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__tMf-p","rotator":"Spinner_rotator__82eKP","path":"Spinner_path__Va0l8","dash":"Spinner_dash__dEAsi","colors":"Spinner_colors__5gWM3"};